import React from "react";

const ContactPage: React.FC = () => {
  return (
    <div>
      <section
        className="min-h-[80vh] sm:min-h-[100vh] flex p-5 lg:px-10 items-center pt-[6rem] md:pt-0"
        style={{
          backgroundImage: "url(/home-hero.svg)",
        }}
      ></section>
    </div>
  );
};

export default ContactPage;
